import { IDateTransformer } from '../DatePresenter';
import { OzDate } from '../oz-date/OzDate';

/**
 * A transformer used to convert dates to PST time.
 */
export class PstTransformer implements IDateTransformer {
    /**
     * Transforms dates from local time into PST. This handles the case of daylight savings time.
     */
    public transform (date: Date): OzDate {
        const ozDate: OzDate = OzDate.fromDate(date);
        const offset: number = PstTransformer._getTimeZoneOffset(date);

        ozDate.setOffset(offset);

        return ozDate;
    }

    private static _isDaylightSavingsTimeActive (date: Date): boolean {
        const targetDate: string = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 10)).toLocaleString('en-US', {
            timeZone: 'America/Los_Angeles',
        });

        const daylightSavingsDate: string = new Date(Date.UTC(date.getUTCFullYear(), 6, 1, 10)).toLocaleString('en-US', {
            timeZone: 'America/Los_Angeles',
        });

        return targetDate.split(', ')[1] === daylightSavingsDate.split(', ')[1];
    }

    private static _getTimeZoneOffset (date: Date): number {
        if (PstTransformer._isDaylightSavingsTimeActive(date)) {
            return -7;
        }

        return -8;
    }
}
